import { authorizedFetch } from "../cloudAuth";

/** Project listing has no `zw-online` equivalent — it's inherently an
 * account-level, multi-project concern that only ever lives on `zw-cloud`,
 * not something a single-session `zw-online` machine could answer. */
export async function listCloudProjects(): Promise<
  { id: string; name: string; lastBackedUpAt: string | null }[]
> {
  const res = await authorizedFetch("/v1/projects");
  if (res.ok === false)
    throw new Error(`Could not list projects (${res.status})`);
  const body = (await res.json()) as {
    projects: {
      id: string;
      name: string;
      last_backed_up_at: string | null;
    }[];
  };
  return body.projects.map((p) => ({
    id: p.id,
    name: p.name,
    lastBackedUpAt: p.last_backed_up_at,
  }));
}
